module.exports = __webpack_public_path__ + "assets/img/Analytics@2x.d9c08dfe.png";